import ReactGA from 'react-ga';

export const initGa = () => {
  //  ga initialize xx
  if (process.env.NODE_ENV !== 'development') {
    ReactGA.initialize('UA-123351797-1', {
      // debug: process.env.NODE_ENV !== "production",
      titleCase: false,
      // @ts-ignore ga文件本地化
      gaAddress: `${process.env.PUBLIC_URL}/analytics.js`,
    });
  }
};

initGa();
